/**
 * 代币图标
 */

interface TokenIconProps {
  tokenIcon: string;
  chainIcon?: string;
}

export default function TokenIcon({ tokenIcon, chainIcon }: TokenIconProps) {
  return (
    <div className="relative shrink-0">
      <img
        src={tokenIcon}
        alt="icon"
        className="w-5 h-5 rounded-full overflow-hidden"
      />
      {chainIcon && (
        <img
          src={chainIcon}
          alt="icon"
          width={12}
          height={12}
          className="absolute -right-0.5 -bottom-0.5 bg-bds-static-white rounded-full border border-bds-static-white"
        />
      )}
    </div>
  );
}
